import React from 'react';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer';
// Viewer code (GltfLoader, Cesium/B3DM loaders) uses Buffer without explicit imports.
(globalThis as unknown as Record<string, unknown>).Buffer ??= Buffer;

declare const __APP_VERSION__: string;

declare global {
  interface Window {
    __SV_ENV?: Record<string, string | undefined>;
  }
}

// Publish Vite env to a global for shared (non-Vite) modules to consume.
// VITE_CLIENT_VERSION is injected from the CLIENT_VERSION env var set by the
// GitLab CI deploy jobs at build time (see vite.config.ts) and is read by
// SkyMapAxiosServiceFactory to send the `skymap-client-version` request
// header for backend-driven cache invalidation (SK-5052 / SK-7015). Empty
// when built outside a release pipeline.
window.__SV_ENV = {
  ...((import.meta as unknown as { env: Record<string, string | undefined> }).env ?? {}),
  VITE_CLIENT_VERSION: __APP_VERSION__,
};
document.documentElement.setAttribute('data-theme', 'default');
// eslint-disable-next-line import/newline-after-import, import/first
import '@legacy-themes/default/css/theme.scss';
// eslint-disable-next-line import/newline-after-import, import/first
import './styles/global.css';
// eslint-disable-next-line import/newline-after-import, import/first
import './i18n/register-locale-loader';
// eslint-disable-next-line import/newline-after-import, import/first
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
